import { Component, inject } from '@angular/core';
import { DataService } from 'src/app/data.service';
import { punktartDisplayLabel, punktartNummerFromLabel } from 'src/app/data-model';
import { KaMaskeComponent } from './ka-maske.component';
import { kaFeldSicher } from './ka-maske';

/**
 * Einmal aus dem Katalog geholt und nicht bei jedem Prüflauf der Vorlage: Die
 * Suche im Katalog läuft über alle Felder des Bogens, und die Vorlage fragt
 * jedes dieser Felder mehrfach.
 */
const FELDER = {
	tkNr: kaFeldSicher('tkNr'),
	projektNr: kaFeldSicher('projektNr'),
	profilNr: kaFeldSicher('profilNr'),
	datum: kaFeldSicher('datum'),
	bearbeiter: kaFeldSicher('bearbeiter'),
	ostwert: kaFeldSicher('ostwert'),
	nordwert: kaFeldSicher('nordwert'),
	hoeheNhn: kaFeldSicher('hoeheNhn'),
	aufschlussart: kaFeldSicher('aufschlussart'),
	aufnahmetiefe: kaFeldSicher('aufnahmetiefe'),
	titelBemerkungen: kaFeldSicher('titelBemerkungen'),
};

/**
 * Maske "Titeldaten" der KA-Aufnahme: die Felder 1 bis 11 des amtlichen Bogens.
 *
 * Sie ist die einzige der vier Masken mit von Hand geschriebenen Zeilen, weil hier
 * die Felder stehen, die im Punkt an ihrer gewohnten Stelle liegen und in jedem
 * Verfahren gleich gelesen werden: Nummer, Datum, Bearbeiter, Koordinaten,
 * Aufnahmetiefe, Bemerkungen. Sie brauchen ihre eigenen Eingabefelder (Datumsfeld,
 * Koordinatensystem) und ihre eigenen Regeln (Gastmodus). Die Felder, die nur die
 * KA hat, kommen wie in den anderen Masken aus dem Feldkatalog.
 */
@Component({
	standalone: false,
	selector: 'bp-ka-titel',
	templateUrl: './ka-titel.component.html',
	styleUrls: ['../../detail/hl-area/hl-area.component.css', './ka-maske.component.css'],
})
export class KaTitelComponent extends KaMaskeComponent {
	protected override get maskeId() { return 'titel' as const; }

	private ds = inject(DataService);

	/**
	 * Die Felder des Bogens, die diese Vorlage einzeln anspricht. Aus dem Katalog
	 * geholt, damit Nummer und Beschriftung an einer Stelle stehen; `kaFeldSicher`
	 * meldet einen Tippfehler beim ersten Testlauf.
	 */
	get f() {
		return FELDER;
	}

	/**
	 * Punktart im Kommentier-Modus: zeigt und sucht die Beschriftung
	 * "Beschreibung (Nummer)", speichert die Nummer. Wie in der SEA-Maske "Aufnahme":
	 * Der Bild-Wähler ist ein reiner Knopf und kann keinen Feld-Kommentar aufnehmen.
	 */
	get punktartModel(): string {
		return punktartDisplayLabel(this.data?.type);
	}
	set punktartModel(label: string) {
		const nummer = punktartNummerFromLabel(label);
		if (nummer) this.data.type = nummer;
	}

	/** Der Bild-Wähler ist kein wd-Feld und meldet die Änderung deshalb selbst. */
	onPunktartPicked(type: string): void {
		this.data.type = type;
		this.vs.dirty.next(true);
	}

	/** Die Liste zeigt die Nummer des Punktes; sie erfährt es über diesen Weg. */
	onNummerChanged(data: { previous: string, current: string }): void {
		this.ds.nummerChanged.emit({ id: this.data._id, num: data.current });
	}
}
